import { styled } from '@mui/material';

const UnstyledList = styled("ul")({
    listStyle: "none",
    margin: 0,
    padding: 0,
});

export { UnstyledList };
//# sourceMappingURL=UnstyledList.js.map
